import BaseEntryProtocolTabState from 'notebook/entries/backbone/tabs/BaseEntryProtocolTab';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {constructOptions, VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';

interface EntryProtocolTabStateDefaults {
  displayOptions: VisibilityOptions;
}

class EntryProtocolTabState extends BaseEntryProtocolTabState {
  override defaults(): EntryProtocolTabStateDefaults & ReturnType<BaseEntryProtocolTabState['defaults']> {
    return {
      ...super.defaults(),
      displayOptions: constructOptions('protocol', [
        {base: vo.ELN_SPELL_CHECK, visible: false, editable: true, sync: true},
        {base: vo.ELN_PRINT_LAYOUT, visible: false, editable: true, sync: true},
      ]),
    };
  }
}

export default EntryProtocolTabState;
